const getTimestampTime = (timestamp?: string | null): number | null => {
  if (!timestamp) return null

  const time = new Date(timestamp).getTime()
  return Number.isFinite(time) ? time : null
}

const getGpsTrackerLocationUpdatedAt = (
  status?: Pick<IGpsTrackerStatus, 'gps_location_updated_at' | 'wifi'> | null,
): string | null => {
  const wifiLocationUpdatedAt = status?.wifi?.resolution_status === 'resolved'
    ? status.wifi.observed_at
    : null

  return [
    status?.gps_location_updated_at,
    wifiLocationUpdatedAt,
  ].reduce<{ timestamp: string | null, time: number }>((latest, timestamp) => {
    const time = getTimestampTime(timestamp)

    if (time === null || time <= latest.time) {
      return latest
    }

    return {
      timestamp: timestamp || null,
      time,
    }
  }, {
    timestamp: null,
    time: Number.NEGATIVE_INFINITY,
  }).timestamp
}

export default getGpsTrackerLocationUpdatedAt
